import * as React from "react";
import * as css from "./GreyResultBackground.scss";

const GreyResultBackground: React.FC = ({ children }) => {
  return <section className={css.background}>{children}</section>;
};

export default GreyResultBackground;
